/**
 * Chrome dimensions shared by both layout paths.
 *
 * The rail width used to be written twice — once on the `Sider` and once as a
 * Tailwind arbitrary value in `AdminShell` — so the 13 DashAI pages silently
 * depended on a literal nobody would think to update. Anything that needs to
 * sit beside the rail reads it from here instead.
 */
export const SIDEBAR_WIDTH = 240;

/** Inline style for a region that must clear the fixed rail. */
export const besideSidebar = {
  marginLeft: `${SIDEBAR_WIDTH}px`,
  width: `calc(100% - ${SIDEBAR_WIDTH}px)`,
};
